export const checkProperty = (obj: { [key: string]: any }, prop: string): boolean =>
  (obj && Object.prototype.hasOwnProperty.call(obj, prop)) || false;
